import { forwardRef } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { Document } from '@/modules/documents/domain/entities/document';

import { DocumentsTableRow } from './documents-table-row';
import type { Sort } from './router/hooks/use-sort';
import { TableSorting } from './ui/components/table-sorting';

export type DocumentsTableProps = {
  documents: Document[];
  loading?: boolean;
  siteId?: string;
  onEditClick: (document: Document) => void;
  sort: Sort<'type' | 'name' | 'required' | 'last_uploaded' | 'uploaded_by'>;
};

const DocumentsTable = forwardRef<HTMLDivElement, DocumentsTableProps>(
  function ({ documents, siteId, onEditClick, sort }, ref) {
    return (
      <Table striped ref={ref} className="table-fixed">
        <TableHead>
          <TableRow>
            <TableHeader>
              <TableSorting
                sort={sort}
                field="required"
                className="ml-2"
              ></TableSorting>
            </TableHeader>
            <TableHeader>
              <TableSorting sort={sort} field="name">
                File name
              </TableSorting>
            </TableHeader>
            <TableHeader>
              <TableSorting sort={sort} field="last_uploaded">
                Last uploaded
              </TableSorting>
            </TableHeader>
            <TableHeader>
              <TableSorting sort={sort} field="uploaded_by">
                Uploaded by
              </TableSorting>
            </TableHeader>
            <TableHeader>
              <TableSorting sort={sort} field="type">
                Type
              </TableSorting>
            </TableHeader>
            <TableHeader>Tags</TableHeader>
            <TableHeader>Actions</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center">
                No Results
              </TableCell>
            </TableRow>
          ) : (
            documents.map((document) => (
              <DocumentsTableRow
                key={document.id}
                document={document}
                onEditClick={onEditClick}
                siteId={siteId}
              />
            ))
          )}
        </TableBody>
      </Table>
    );
  },
);

DocumentsTable.displayName = 'DocumentsTable';
export { DocumentsTable };
